import {IntegrationSchemaEntity} from './integration-schema-entity';

export class SchemaEntities {
  constructor() {

  }
  schemaEntities: IntegrationSchemaEntity[] = [];
}
